import React from 'react';

const ProgressBar = ({ progress }) => {
    return (
        <div className="relative flex items-center gap-2.5 py-1.5">
            <div className="relative  w-full h-3  overflow-hidden rounded-3xl bg-gray-100">
                <div
                    role="progressbar"
                    aria-valuenow={progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: `${progress}%` }}
                    className="flex h-full items-center justify-center bg-indigo-600 text-white rounded-3xl"
                >
                    <span className="ml-2 bg-transparent  rounded-full  text-gray-100 text-xs font-medium flex justify-center items-center ">
                        {progress}%
                    </span>
                </div>

            </div>
        </div>
    );
};

export default ProgressBar;
{/* <div className="relative flex items-center gap-2.5 py-1.5">
    <div className="relative  w-full h-2.5  overflow-hidden rounded-3xl bg-gray-100">
        <div role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style={{ width: '100%' }} className="flex h-full items-center justify-center bg-indigo-600  text-white rounded-3xl"></div>
    </div>
    <span className="ml-2 bg-transparent  rounded-full  text-gray-100 text-sm font-medium flex justify-center items-center ">100%</span>
</div> */}